<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        @if (!loading) {
            <div class="col-md-12">
                {{ isEditMode ? "Edit" : "Create" }} Document Type{{
                    isEditMode ? ` - ${documentType.DocumentTypeName}` : ""
                }}
            </div>
        }
    </div>
    <div>&nbsp;</div>
    @if (!isEditMode) {
        <div class="col-md-12" style="color: red">All fields are required</div>
    }
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-heading">General</div>
            <div class="panel-body">
                <form #frm="ngForm" class="form-horizontal">
                    <div class="form-group">
                        <label for="documenTypeName" class="col-md-1 control-label"> Name </label>
                        <div class="col-md-4">
                            @if (isEditMode) {
                                <input
                                    id="documentTypeName"
                                    class="form-control"
                                    type="text"
                                    [value]="documentType.DocumentTypeName"
                                    readonly
                                    disabled />
                            } @else {
                                <input
                                    name="documentTypeName"
                                    type="text"
                                    required
                                    maxlength="255"
                                    #docTypeNameMdl="ngModel"
                                    class="form-control"
                                    [(ngModel)]="documentType.DocumentTypeName" />
                                @if (docTypeNameMdl.touched && docTypeNameMdl.invalid) {
                                    <span class="text-danger"> Document Type Name is required </span>
                                }
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="fileType" class="col-md-1 control-label"> File Type </label>
                        <div class="col-md-4">
                            @if (isEditMode) {
                                <input
                                    id="fileType"
                                    class="form-control"
                                    type="text"
                                    [value]="documentType.FileType.FileTypeName"
                                    readonly
                                    disabled />
                            } @else {
                                <nz-select
                                    name="fileType"
                                    nzShowSearch
                                    nzSelectOnTab
                                    [nzShowArrow]="false"
                                    required
                                    style="width: 100%"
                                    #docTypeNameMdl="ngModel"
                                    [nzOptions]="selectableFileTypes"
                                    [(ngModel)]="selectedFileType"
                                    nzPlaceHolder="Click to select/search for a file type"></nz-select>
                                @if (docTypeNameMdl.touched && docTypeNameMdl.invalid) {
                                    <span class="text-danger"> File Type is required </span>
                                }
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>
        @if (isEditMode) {
            <div class="panel panel-default">
                <div class="panel-heading">Details</div>
                <div class="panel-body">
                    <nz-tabs nzType="card" style="margin-top: 16px">
                        <nz-tab id="keyword-panel" [nzTitle]="keywords">
                            <div class="panel-body">
                                <nz-table
                                    #keywordTable
                                    [nzData]="docTypeKeywords"
                                    nzTableLayout="fixed"
                                    nzShowPagination="false"
                                    emptyText="No keywords found"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of keywordColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of keywordTable.data; track data.MetaDataDefinitionID) {
                                            <tr>
                                                <td>{{ data.Name }}</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        nz-input
                                                        style="width: 100%"
                                                        maxlength="255"
                                                        #keywordRegexMdl="ngModel"
                                                        [(ngModel)]="data.Regex"
                                                        (ngModelChange)="onRegexChange($event, data)" />
                                                    @if (!data.RegexIsValid) {
                                                        <span class="text-danger"> Invalid regex pattern </span>
                                                    }
                                                </td>
                                                <td>
                                                    @if (data.DateFormatString.length) {
                                                        <input
                                                            [name]="`dateformat_${data.MetaDataDefinitionID}`"
                                                            [id]="`dateformat_${data.MetaDataDefinitionID}`"
                                                            type="text"
                                                            nz-input
                                                            style="width: 100%"
                                                            maxlength="255"
                                                            [(ngModel)]="data.DateFormatString"
                                                            nz-tooltip
                                                            [nzTooltipTitle]="`Format example: ${(today | date: data.DateFormatString)}`" />
                                                    } @else {
                                                        <input
                                                            [name]="`dateformat_${data.MetaDataDefinitionID}`"
                                                            [id]="`dateformat_${data.MetaDataDefinitionID}`"
                                                            type="text"
                                                            nz-input
                                                            style="width: 100%"
                                                            maxlength="255"
                                                            [(ngModel)]="data.DateFormatString" />
                                                    }
                                                </td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        [name]="`required_${data.MetaDataDefinitionID}`"
                                                        [id]="`required_${data.MetaDataDefinitionID}`"
                                                        nzSize="small"
                                                        [(ngModel)]="data.Required"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl">
                                                    </nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <nz-input-number
                                                        nzMin="0"
                                                        style="width: 100%"
                                                        [(ngModel)]="data.DisplayOrder" />
                                                </td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        [name]="`display_${data.MetaDataDefinitionID}`"
                                                        [id]="`display_${data.MetaDataDefinitionID}`"
                                                        nzSize="small"
                                                        [(ngModel)]="data.DisplayOnList"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl">
                                                    </nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.Name }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removeKeyword(data.MetaDataDefinitionID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 70%; align-items: center; gap: 8px; margin-top: 8px">
                                    <nz-select
                                        nzShowSearch
                                        nzSelectOnTab
                                        nzAllowClear
                                        [nzShowArrow]="false"
                                        style="width: 100%"
                                        [nzOptions]="selectableKeywords"
                                        [(ngModel)]="selectedKeyword"
                                        nzPlaceHolder="Click here to add keywords"></nz-select>
                                    <button
                                        nz-tooltip="Add Keyword"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="addKeyword(selectedKeyword)">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab id="keyword-alias-panel" [nzTitle]="keywordAliases">
                            <div class="panel-body">
                                <nz-table
                                    #keywordAliasTable
                                    [nzData]="documentType.KeywordAliases"
                                    nzTableLayout="fixed"
                                    nzShowPagination="false"
                                    emptyText="No aliases found"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of keywordAliasColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of keywordAliasTable.data; track data.MetaDataDefinitionAliasID) {
                                            <tr>
                                                <td>{{ data.KeywordName }}</td>
                                                <td>{{ data.Alias }}</td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.KeywordName }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removeKeywordAlias(data.MetaDataDefinitionAliasID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 100%; align-items: center; gap: 8px; margin-top: 8px">
                                    <nz-select
                                        nzShowSearch
                                        nzSelectOnTab
                                        nzAllowClear
                                        [nzShowArrow]="false"
                                        style="width: 70%"
                                        [nzOptions]="selectableAliasKeywords"
                                        [(ngModel)]="selectedAliasKeyword"
                                        nzPlaceHolder="Click here to select keyword"></nz-select>
                                    <input
                                        name="keyword_alias"
                                        id="keyword_alias"
                                        type="text"
                                        nz-input
                                        style="width: 30%"
                                        maxlength="255"
                                        placeholder="Enter alias"
                                        [(ngModel)]="keywordAlias" />
                                    <button
                                        nz-tooltip="Add Keyword Alias"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="addKeywordAlias()">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab id="alias-panel" [nzTitle]="docTypeAliases">
                            <div class="panel-body">
                                <nz-table
                                    #docTypeAliasTable
                                    [nzData]="documentType.Aliases"
                                    nzTableLayout="fixed"
                                    nzShowPagination="false"
                                    emptyText="No alias assigned"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of docTypeAliasColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of docTypeAliasTable.data; track data.DocumentTypeAliasID) {
                                            <tr>
                                                <td>{{ data.DocumentTypeAliasName }}</td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.DocumentTypeAliasName }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removeDocTypeAlias(data.DocumentTypeAliasID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 50%; align-items: center; gap: 8px; margin-top: 8px">
                                    <input
                                        type="text"
                                        nz-input
                                        style="width: 100%"
                                        maxlength="250"
                                        [(ngModel)]="docTypeAlias"
                                        placeholder=" Enter alias" />
                                    <button
                                        nz-tooltip="Add Alias"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="addDocTypeAlias()"
                                        [disabled]="!docTypeAlias.trim().length">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                    </nz-tabs>
                </div>
            </div>
        }
        <div style="margin-top: 20px">
            @if (!isEditMode) {
                <button class="btn btn-default" (click)="create(frm)">Create</button>
            }
            @if (isEditMode) {
                <button class="btn btn-default" (click)="save()">Save</button>
            }
            @if (!isEditMode) {
                <button class="btn btn-default" (click)="goBack()">Cancel</button>
            }
            @if (isEditMode) {
                <button
                    class="btn btn-default"
                    (click)="reset()"
                    nz-tooltip="Undo all changes since the last successful save">
                    Reset
                </button>
            }
            @if (isEditMode) {
                <button class="btn btn-default" (click)="goBack()">Back To Document Types</button>
            }
            <div class="pull-right">
                @if (documentType.DocumentTypeID) {
                    <button class="btn btn-danger" (click)="RemoveDocType(removeDocTypeModal)">
                        Delete Document Type
                    </button>
                }
            </div>
        </div>
    </div>
</div>
<ng-template #checkedTmpl><nz-icon nzType="check" /></ng-template>
<ng-template #uncheckedTmpl><nz-icon nzType="close" /></ng-template>
<ng-template #keywords><span style="font-weight: bold">Keywords</span></ng-template>
<ng-template #keywordAliases><span style="font-weight: bold">Keyword Aliases</span></ng-template>
<ng-template #docTypeAliases><span style="font-weight: bold">Aliases</span></ng-template>
<ng-template #removeDocTypeModal>
    <div class="modal-header">
        Delete Document Type: <strong>{{ documentType.DocumentTypeName }}</strong>
    </div>
    <form (ngSubmit)="remove()" role="form">
        <div class="modal-body">
            <div class="form-group">
                <div>
                    Are you sure you want to delete this document type? <br />
                    <h5 style="color: rgb(230, 0, 0)">Warning: All documents will be deleted for the document type</h5>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
            <button type="submit" class="btn btn-danger">Delete Document Type</button>
        </div>
    </form>
</ng-template>
